import { useRequest } from "@/shared/composables/useRequest.ts";
import { HttpClientService } from "@/shared/services/http_client/HttpClientService.ts";
import { NotificationsRepository } from "@/app/header/notifications/repositories/NotificationsRepository";

export function markAllNotificationsController() {
  const repository: NotificationsRepository = new NotificationsRepository(new HttpClientService());

  return useRequest<void>({
    fn: async (userId: string | number) => await repository.markAllNotifications(userId),
    notifyOptions: {
      success: true,
    },
  });
}
